import { ReactComponent as ChatIcon } from '../icons/main_menu/chat.svg';
import ChatList from './ChatList';
import ChatPage from './ChatPage';

const exports = {
    Page: ChatPage,
    List: ChatList,
    Icon: ChatIcon,
};
export default exports;
